import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';
import { Actions } from '../actions/emails-log-actions';
import { EmailLogActions } from '../constants';
import { IEmailLog } from 'src/types/email-log';

export interface EmailsLogState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IEmailLog>;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
};

export function emailsLog(state: EmailsLogState = initialState, action: Actions | any): EmailsLogState {
    switch (action.type) {
        case requestType(EmailLogActions.FETCH_EMAILS_LOG):
            return { ...state, error: '', inProgress: true };
        case successType(EmailLogActions.FETCH_EMAILS_LOG):
            return { ...state, data: action.payload, inProgress: false };
        case failureType(EmailLogActions.FETCH_EMAILS_LOG):
            return { ...state, error: action.error, inProgress: false };
        default:
            return state;
    }
}
